import { EnvLevel, getEnvLevel } from './getEnvLevel';

export const getCoachHubUrl = () => {
  const nodeEnv = process.env.NODE_ENV;
  const envLevel = getEnvLevel();

  if (envLevel === EnvLevel.PROD) {
    throw new Error('Not supported in prod');
  }

  if (nodeEnv === 'development') {
    return 'http://localhost:8000';
  }

  return `https://coach.${envLevel}.prince.ex-os.net`;
};
